import type { PnlHierarchyMember } from 'src/components/star-grid/starGridTypes';

/** The tree with its leaf positions dropped, so a filter stops at the roll-ups. */
export const rollupsOnlyMembers = (members: readonly PnlHierarchyMember[]): PnlHierarchyMember[] =>
  members.filter((member) => !member.is_leaf).map((member) => ({ ...member, children: rollupsOnlyMembers(member.children ?? []) }));
